import React from 'react';
import {MessageText} from './styles';

interface TextWithLinkDetectionProps {
  text: string;
}

const TextWithLinkDetection: React.FC<TextWithLinkDetectionProps> = ({
  text,
}) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  const renderTextWithLinks = (text: string): JSX.Element[] => {
    return text.split(urlRegex).map((part, index) => {
      return urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          style={{color: '#fff'}}
        >
          {part}
        </a>
      ) : (
        <span key={index}>{part}</span>
      );
    });
  };

  return <MessageText>{renderTextWithLinks(text)}</MessageText>;
};

export default TextWithLinkDetection;
